import { useStripe, useElements, PaymentElement } from "@stripe/react-stripe-js";
import { Button } from 'primereact/button'
import { Message } from 'primereact/message'
import { useCallback } from "react";
import { useTranslation } from "gatsby-plugin-react-i18next";
import { PaymentForm, PaymentFormRow } from './styles';

const CheckoutForm = ({ state, dispatch }) => {
  const stripe = useStripe()
  const elements = useElements()
  const { t } = useTranslation()

  const handleChange = useCallback((event) => {
    dispatch({ type: 'change', isDisabled: event.empty, error: event.error ? event.error.message : '' })
  }, [dispatch])

  const handleSubmit = useCallback(async (event) => {
    event.preventDefault()

    dispatch({ type: 'processing' })

    const payload = await stripe.confirmPayment({
      elements,
      redirect: 'if_required'
    })

    if (payload.error) {
      dispatch({ type: 'change', isDisabled: false, error: payload.error.message })
    } else {
      dispatch({ type: 'succeeded' })
    }
  }, [stripe, elements, dispatch])

  const handlePaymentReady = useCallback(() => {
    dispatch({ type: 'enable' })
  }, [dispatch])

  return (
    <PaymentForm onSubmit={handleSubmit}>
      <PaymentElement id='payment-element' onChange={handleChange} onReady={handlePaymentReady} />
      <PaymentFormRow>
        <Button disabled={state.isDisabled || state.isProcessing} type="submit">{t('pay')}</Button>
      </PaymentFormRow>
      <PaymentFormRow>
        {state.error && (
          <Message severity="error" text={state.error} />
        )}
        {state.hasSucceeded && (
          <Message severity="success" text={t('Payment Success')} />
        )}
      </PaymentFormRow>
    </PaymentForm>
  )
}

export default CheckoutForm
